import { motion } from 'framer-motion';
import { ImAirplane } from 'react-icons/im';

export default function FlightSegment({ segment = {} }) {
  const { flightNumber, pieceCount, departure, arrival } = segment;
  const hasFlightInfo =
    flightNumber && pieceCount != null && departure && arrival;

  return (
    <div className='fsx' role='group' aria-label='Flight segment'>
      {hasFlightInfo ? (
        <div className='d-flex flex-column'>
          <motion.div
            className='fsx-top'
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            layout
          >
            <div className='fsx-title align-items-end'>
              <span className='fsx-flight'>{flightNumber}</span>
              <span className='fsx-dot' aria-hidden>
                •
              </span>
              <span className='fsx-pieces'>
                <span className='num'>{pieceCount}</span> pcs
              </span>
            </div>
          </motion.div>

          <div className='line' style={{ width: '100%' }} />
          <motion.div
            className='fsx-bottom'
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2, ease: 'easeOut' }}
            layout
          >
            <div className='fsx-row px-3'>
              <div className='fsx-col'>
                <div className='fsx-label gap-3'>
                  <motion.span
                    className='fsx-ico'
                    initial={{ x: 0, y: 0, rotate: 90 }}
                    animate={{
                      x: [0, 12, 0],
                      y: [0, -6, 0],
                    }}
                    transition={{
                      duration: 4.2,
                      repeat: Infinity,
                      ease: 'easeInOut',
                      delay: 0.15,
                    }}
                  >
                    <ImAirplane size={14} />
                  </motion.span>
                  DEP
                </div>
                <div className='fsx-when'>{departure}</div>
              </div>
              <div className='fsx-arrow' aria-hidden>
                →
              </div>
              <div className='fsx-col'>
                <div className='fsx-label gap-3'>
                  <motion.span
                    className='fsx-ico'
                    initial={{ x: 0, y: -3, rotate: 180 }}
                    animate={{
                      x: [0, 8, 0],
                      y: [-3, 3, -3],
                    }}
                    transition={{
                      duration: 4.2,
                      repeat: Infinity,
                      ease: 'easeInOut',
                      delay: 0.15,
                    }}
                  >
                    <ImAirplane size={14} />
                  </motion.span>
                  ARR
                </div>
                <div className='fsx-when'>{arrival}</div>
              </div>
            </div>
          </motion.div>
        </div>
      ) : (
        <div className='line' style={{ width: '60px' }} />
      )}
    </div>
  );
}
